// ============ EDITA AQUÍ ============

// Host
export const HOST_NAME = 'Chale Rodriguez';
export const HOST_FIRST = 'Chale';
export const BRAND = 'Chale Rodriguez';

// Barra superior
export const HEADER_TITLE = 'Llamada 1:1 con Chale';
export const HEADER_LOGO_URL = ''; // opcional: logo/firma en blanco (PNG). Vacío = ícono por defecto

// Etiqueta de disponibilidad (la cuenta regresiva cierra el domingo 11:59 PM de la semana actual)
export const WEEK_LABEL = 'Cupos de esta semana: lunes a sábado';

// Imágenes (URLs). Vacío = placeholder
export const HOST_PHOTO_URL = 'https://cdn.magicpatterns.com/uploads/eWumkXbWv3ps3dtsjchGyW/image.png'; // retrato profesional de Chale
export const COLLAGE_URL = '';      // collage de Chale trabajando (sección "Hoy…")
// Fila de fotos circulares. Hoy son IMÁGENES ILUSTRATIVAS (generadas), no personas reales del equipo.
// Cuando Chale tenga fotos reales de su comunidad (con permiso), reemplázalas y cambia AVATARS_ILLUSTRATIVE a false.
export const AVATAR_URLS: string[] = [
  'https://cdn.magicpatterns.com/patterns/generated-images/4c8f8eca-1214-4826-ae36-8936aec9717a.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/f2e7a3fc-87b5-4e7d-9916-a42d14261d81.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/29ed3932-b38f-4c0b-b86a-b50be26ea27f.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/34d31eb6-0e27-4e16-a701-cb8ed68cf266.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/c364ac92-29ac-4b58-841b-b75180e59b9f.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/9b68678f-c10f-4ca2-b6c4-cb2ca94c8c3e.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/215f3200-b817-46eb-a64c-46201e35c261.jpg',
  'https://cdn.magicpatterns.com/patterns/generated-images/e579847f-7d13-4f0d-aaa5-de3b587aa805.jpg',
];
export const AVATARS_ILLUSTRATIVE = true; // true = muestra "Imágenes ilustrativas" y oculta estrellas/sello

// Datos reales para los badges junto a la foto
export const BADGE_LEFT = { title: 'Instagram', value: '9K+' };
export const BADGE_RIGHT = { title: 'Basada en', value: 'Miami' };

// Video de la página de agenda (explicativo 4–6 min)
// OPCIÓN A: link de YouTube (no listado). Arranca en silencio; al hacer clic se activa el sonido.
export const TYP_YOUTUBE_URL = '';
// OPCIÓN B: embed de Bunny/Vimeo. Se usa solo si TYP_YOUTUBE_URL está vacío.
export const TYP_VIDEO_EMBED_URL = '';
export const TYP_VIDEO_POSTER_URL = '';

// Calendario de GoHighLevel: link del widget (Calendars → Share → Embed → el "src" del iframe)
// Ej: https://api.leadconnectorhq.com/widget/booking/XXXXXXXX
// En GHL → Confirmation → "Redirect to URL": <dominio>/#/confirmada
// (Opcional) para mostrar la fecha en la página final: <dominio>/#/confirmada?fecha={{appointment.start_time}}
export const GHL_CALENDAR_EMBED_URL = '';

// Meta Pixel
export const META_PIXEL_ID = 'YOUR_PIXEL_ID';

// Webhook GHL (Inbound Webhook). Se envía en el paso 1 (datos) y en el paso 2 (respuestas).
export const LEAD_WEBHOOK_URL = '';

// SEO y vistas previas al compartir el link
export const SITE_URL = '';      // dominio final, ej: https://chalerodriguez.com (para el canonical). Vacío = se omite
export const OG_IMAGE_URL = '';  // imagen para WhatsApp/Facebook/Instagram, 1200x630 px. Vacío = se omite
export const INSTAGRAM_URL = ''; // perfil de Instagram de Chale (datos estructurados). Vacío = se omite

// Links y footer
export const WHATSAPP_URL = 'https://wa.me/1XXXXXXXXXX';
export const CONTACT_EMAIL = 'info@bychale.com';
export const PRIVACY_URL = '#/privacidad';
export const TERMS_URL = '#/terminos';
